import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';

import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: {
    validators: [
      validator('presence', true),
      validator('format', {
        regex: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
        messageKey: 'forms.url-alias.messages.name.format',
      }),
      validator('unique', {
        messageKey: 'forms.url-alias.messages.name.unique',
      }),
    ],
  },
});

export default class UrlAliasModel extends Model.extend(Validations) {
  @attr('string') name;

  // CMS fields
  @attr('string', { defaultValue: '1' }) cmsLanguageId;
  @attr('number') position;
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('artist', { async: true, inverse: null }) artist;
  @belongsTo('web-series', { async: true, inverse: null }) webSeries;
  @belongsTo('url-alias', { async: true, inverse: null }) parent;

  // Getter and setter
  @alias('name') displayHeadline;
  @alias('name') headline;

  get displayLabel() {
    return `${this.name} (${this.id})`;
  }

  @computed('artist')
  get hasArtist() {
    return this.belongsTo('artist').id() !== null;
  }

  @computed('webSeries')
  get hasWebSeries() {
    return this.belongsTo('webSeries').id() !== null;
  }
}
